__turbopack_context__.v({
  "avatar": "Header-module-scss-module__wS1-Va__avatar",
  "avatarPlaceholder": "Header-module-scss-module__wS1-Va__avatarPlaceholder",
  "block": "Header-module-scss-module__wS1-Va__block",
  "container": "Header-module-scss-module__wS1-Va__container",
  "fadeIn": "Header-module-scss-module__wS1-Va__fadeIn",
  "loginBtn": "Header-module-scss-module__wS1-Va__loginBtn",
  "logo": "Header-module-scss-module__wS1-Va__logo",
  "logoutBtn": "Header-module-scss-module__wS1-Va__logoutBtn",
  "menu": "Header-module-scss-module__wS1-Va__menu",
  "profile": "Header-module-scss-module__wS1-Va__profile",
  "shimmer": "Header-module-scss-module__wS1-Va__shimmer",
  "skeletonAvatar": "Header-module-scss-module__wS1-Va__skeletonAvatar",
  "skeletonButton": "Header-module-scss-module__wS1-Va__skeletonButton",
  "skeletonProfile": "Header-module-scss-module__wS1-Va__skeletonProfile",
  "userBox": "Header-module-scss-module__wS1-Va__userBox",
  "wrapper": "Header-module-scss-module__wS1-Va__wrapper",
});
